import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Form5471TextinfoService {

  constructor(private http: HttpClient) {}

  private buildHttpParams(params: any): HttpParams {
    let httpParams = new HttpParams();
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const value = params[key];
        if (value !== null && value !== undefined) {
          httpParams = httpParams.set(key,
            typeof value === 'object' ? JSON.stringify(value) : String(value)
          );
        }
      }
    }
    return httpParams;
  }

  private buildFormData(params: any): string {
    const formData: string[] = [];
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const value = params[key];
        if (value !== null && value !== undefined) {
          formData.push(encodeURIComponent(key) + '=' + encodeURIComponent(
            typeof value === 'object' ? JSON.stringify(value) : value
          ));
        }
      }
    }
    return formData.join('&');
  }

  private getPostHttpOptions() {
    return {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' }),
      withCredentials: true
    };
  }

  getFilingGroup(baseUrl: string, params: any, globalService: any, filterParams?: any): Observable<any> {
    const mergedParams = { ...globalService, ...(filterParams || {}), ...params, action_code: 'f5sne6' };
    return this.http.get(`${baseUrl}/loadJsonObject`, { params: this.buildHttpParams(mergedParams), withCredentials: true });
  }

  getFormData(baseUrl: string, params: any, globalService: any, filterParams?: any): Observable<any> {
    const mergedParams = { ...globalService, ...(filterParams || {}), ...params, action_code: 'cv31te' };
    return this.http.get(`${baseUrl}/loadJsonObject`, { params: this.buildHttpParams(mergedParams), withCredentials: true });
  }

  getCatgFilerData(baseUrl: string, params: any, globalService: any, filterParams?: any): Observable<any> {
    const mergedParams = { ...globalService, ...(filterParams || {}), ...params, action_code: 'ot2ww8' };
    return this.http.get(`${baseUrl}/loadJsonObject`, { params: this.buildHttpParams(mergedParams), withCredentials: true });
  }

  get5471Line1Data(baseUrl: string, params: any, globalService: any, filterParams?: any): Observable<any> {
    const mergedParams = { ...globalService, ...(filterParams || {}), ...params, action_code: 'sslirf' };
    return this.http.get(`${baseUrl}/loadJsonObject`, { params: this.buildHttpParams(mergedParams), withCredentials: true });
  }

  getPrincipalBusinessActivity(baseUrl: string, globalService: any, filterParams?: any): Observable<any> {
    const mergedParams = { ...globalService, ...(filterParams || {}), action_code: 'y5ypqx' };
    return this.http.get(`${baseUrl}/loadJsonObject`, { params: this.buildHttpParams(mergedParams), withCredentials: true });
  }

  getTransId(baseUrl: string, params: any, globalService: any, filterParams?: any): Observable<any> {
    const mergedParams = { ...globalService, ...(filterParams || {}), ...params, action_code: 'b2d73q' };
    return this.http.get(`${baseUrl}/loadJsonObject`, { params: this.buildHttpParams(mergedParams), withCredentials: true });
  }

  getCountries(baseUrl: string, params: any, globalService: any, filterParams?: any): Observable<any> {
    const mergedParams = { ...globalService, ...(filterParams || {}), ...params, action_code: 'kbuwei' };
    return this.http.get(`${baseUrl}/loadJsonObject`, { params: this.buildHttpParams(mergedParams), withCredentials: true });
  }

  getCurrencies(baseUrl: string, params: any, globalService: any, filterParams?: any): Observable<any> {
    const mergedParams = { ...globalService, ...(filterParams || {}), ...params, action_code: '3ucwjb' };
    return this.http.get(`${baseUrl}/loadJsonObject`, { params: this.buildHttpParams(mergedParams), withCredentials: true });
  }

  getStates(baseUrl: string, params: any, globalService: any, filterParams?: any): Observable<any> {
    const mergedParams = { ...globalService, ...(filterParams || {}), ...params, action_code: '6eyqnz' };
    return this.http.get(`${baseUrl}/loadJsonObject`, { params: this.buildHttpParams(mergedParams), withCredentials: true });
  }

  getScheduleGData(baseUrl: string, params: any, globalService: any, filterParams?: any): Observable<any> {
    const mergedParams = { ...globalService, ...(filterParams || {}), ...params, action_code: 'pru0jb' };
    return this.http.get(`${baseUrl}/loadJsonObject`, { params: this.buildHttpParams(mergedParams), withCredentials: true });
  }

  getScheduleICheckboxData(baseUrl: string, params: any, globalService: any, filterParams?: any): Observable<any> {
    const mergedParams = { ...globalService, ...(filterParams || {}), ...params, action_code: '2pql6p' };
    return this.http.get(`${baseUrl}/loadJsonObject`, { params: this.buildHttpParams(mergedParams), withCredentials: true });
  }

  getScheduleIData(baseUrl: string, params: any, globalService: any, filterParams?: any): Observable<any> {
    const mergedParams = { ...globalService, ...(filterParams || {}), ...params, action_code: 'n33ft3' };
    return this.http.get(`${baseUrl}/loadJsonObject`, { params: this.buildHttpParams(mergedParams), withCredentials: true });
  }

  saveForm5471ScheduleNA(baseUrl: string, settings: any, details: any, globalService: any, filterParams: any): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=eu8fpf`;
    let params = _.merge({}, globalService || {}, filterParams || {});
    params.jsonObj = JSON.stringify(details);
    params.jsonSettings = JSON.stringify(settings);
    params.process_name = 'Form_5471_Schedule_NA_Save';
    return this.http.post(url, this.buildFormData(params), this.getPostHttpOptions());
  }

  saveForm5471ScheduleG(baseUrl: string, settings: any, details: any, globalService: any, filterParams: any): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=vlm7h1`;
    let params = _.merge({}, globalService || {}, filterParams || {});
    params.jsonObj = JSON.stringify(details);
    params.jsonSettings = JSON.stringify(settings);
    params.process_name = 'Form_5471_Schedule_G_Save';
    return this.http.post(url, this.buildFormData(params), this.getPostHttpOptions());
  }

  // Parity alias for AngularJS scheduleGServiceFactory.saveScheduleG
  saveScheduleG(baseUrl: string, settings: any, details: any, globalService: any, filterParams: any): Observable<any> {
    return this.saveForm5471ScheduleG(baseUrl, settings, details, globalService, filterParams);
  }

  saveScheduleGInline(
    baseUrl: string, actionCode: string, jsonObj: any, jsonSettings: any,
    processName: string, globalParams: any, filterParams: any
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=${actionCode}`;
    let params = _.merge({}, globalParams || {}, filterParams || {});
    params.jsonObj = JSON.stringify(jsonObj);
    params.jsonSettings = JSON.stringify(jsonSettings);
    params.process_name = processName;
    return this.http.post(url, this.buildFormData(params), this.getPostHttpOptions());
  }

  saveForm5471ScheduleI(baseUrl: string, settings: any, details: any, globalService: any, filterParams: any): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=wo6vaz`;
    let params = _.merge({}, globalService || {}, filterParams || {});
    params.jsonObj = JSON.stringify(details);
    params.jsonSettings = JSON.stringify(settings);
    params.process_name = 'Form_5471_Schedule_I_Save';
    return this.http.post(url, this.buildFormData(params), this.getPostHttpOptions());
  }
}
